import { useMemo } from 'react';
import { useFormHook, useSetError } from '@Hooks/index';
import { OnboardingFormFields } from '@Types/index';
import { ownersCenterScheme } from '../OwnersCenterForm/ownersCenterScheme';
import { UBO_INDEX_TO_FIELD_NAME } from '../ownersCenter.consts';
import type { UboResponse } from '@Store/index';
import type { OwnersCenterFormType } from '../OwnersCenterForm/OwnersCenterForm.types';

export const useOwnersCenterForm = (
  businessOwners: UboResponse[] | undefined,
  mainOwner: UboResponse
) => {
  const defaultValues = useMemo(() => {
    const uboDefaults = Object.fromEntries(
      UBO_INDEX_TO_FIELD_NAME.map((field, i) => [field, businessOwners?.[i]?.ownershipPercent])
    );

    return {
      [OnboardingFormFields.OWNER_PERCENTAGE]: mainOwner.ownershipPercent ?? 100,
      [OnboardingFormFields.OWNER_CENTER_CONSENT]: false,
      ...uboDefaults,
    } as OwnersCenterFormType;
  }, [businessOwners, mainOwner.ownershipPercent]);

  const formMethods = useFormHook({
    formSchema: ownersCenterScheme,
    formDefaultValues: defaultValues,
    values: defaultValues,
    schemaTitle: 'owners-center-form',
    reValidateMode: 'onChange',
  });

  useSetError({ formMethods });

  return formMethods;
};
